import React, { useRef } from 'react';

const PritntPdfTable = (tableName = 'Data') => {
    const printTableRef = useRef(null);

    const handleDownloadPdf = () => {
        if (!printTableRef?.current) {
            console.error('Print reference is not defined');
            return;
        }

        // Clone the table content to manipulate without affecting the original table
        const content = printTableRef.current.cloneNode(true);

        // Remove the action column from the table
        const actionColumns = content.querySelectorAll('.hidden-print-remove');
        actionColumns.forEach((column) => column.remove());

        // Create and configure the print iframe
        const printFrame = document.createElement('iframe');

        // Make iframe invisible
        printFrame.style.display = 'none';
        document.body.appendChild(printFrame);

        // Get the iframe's document
        const frameDoc = printFrame.contentWindow?.document;
        if (!frameDoc) {
            console.error('Cannot access iframe document');
            return;
        }

        // Copy your page's styles to the print iframe
        const styles = document.getElementsByTagName('style');
        const links = document.getElementsByTagName('link');

        frameDoc.open();
        frameDoc.write(`
          <html>
                <head>
                    <title>${tableName}</title>
                    <style>
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            text-align: left;
                        }
                        th, td {
                            padding: 8px;
                            border: 1px solid #ddd;
                        }
                        th {
                            background-color: #f4f4f4;
                        }
                    </style>
                </head>
                <body>
              ${content.innerHTML}
            </body>
          </html>
        `);
        frameDoc.close();

        // Wait for all resources to load before printing
        const handleLoad = () => {
            try {
                printFrame.contentWindow?.focus();
                printFrame.contentWindow?.print();
            } catch (error) {
                console.error('Print error:', error);
            } finally {
                // Cleanup: remove the iframe after printing
                setTimeout(() => {
                    document.body.removeChild(printFrame);
                }, 100);
            }
        };

        if (printFrame.contentWindow?.document.readyState === 'complete') {
            handleLoad();
        } else {
            printFrame.onload = handleLoad;
        }
    };

    return { printTableRef, handleDownloadPdf };
};
export default PritntPdfTable;
